import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import neighborhoodStreetIntersectionReadAction from './neighborhoodStreetIntersectionRead.action.json' with { type: 'json' }

const neighborhoodStreetIntersectionReadDefinition = defineReadAutoAction(
  neighborhoodStreetIntersectionReadAction,
  'neighborhoodStreetIntersection',
)

export default neighborhoodStreetIntersectionReadDefinition
